/**
 * This has to be listed here:
 *   app/public/wp-content/mu-plugins/wp-common-plugin/src/Gutenberg/Blocks/webpack.config.js
 */
( function() {
	'use strict';

	function initStateSelects() {

		const blocks = document.querySelectorAll( '.product-block' );

		if ( !blocks.length ) {
			return;
		}

		const searchParams = new URLSearchParams( window.location.search );
		const stateSlug = searchParams.get( 'state' );

		blocks.forEach( block => {
			const selectStates = block.querySelector( '.js-product-states' );
			const container = block.closest( '.card' ) || block; // If .card is not found, container is block itself.

			if ( selectStates ) {

				selectStates.addEventListener( 'change', function() {
					onStateChange( this.value, container );
				} );

				container.querySelectorAll( '.add-to-cart-container' ).forEach( element => {
					element.dataset.productCode = '';
					element.querySelectorAll( 'button' ).forEach( button => {
						button.classList.add( 'no-click' );
						button.textContent = 'View Price';
					} );
				} );

				if ( stateSlug ) {
					let found = null;
					selectStates.querySelectorAll( 'option' ).forEach( opt => {
						if ( opt.textContent.toLowerCase().replace( /\s+/g, '-' ) === stateSlug ) {
							opt.selected = true;
							found = opt;
							selectStates.dispatchEvent( new Event( 'change' ) );
							return false; //break out of the forEach loop
						}
					} );
				}
			}
		} );

		function onStateChange( productCode, card ) {

			const url = `${window.location.protocol}//${window.location.host}/?cg-ajax-content=product-modal&product_codes=${productCode}`;
			card.querySelector( '.add-to-cart-container button' ).disabled = true;
			card.classList.add( 'loading' );

			fetch( url, { method: 'GET', headers: { 'Content-Type': 'text/html' } } )
			.then( response => response.text() )
			.then( response => {
				card.classList.remove( 'loading' );

				const tempDiv = document.createElement( 'div' );
				tempDiv.innerHTML = response;

				const title = tempDiv.querySelector( '.product__title' );
				if ( title ) {
					card.querySelectorAll( '.product__title' ).forEach( el => {
						el.replaceWith( title.cloneNode( true ) );
					} );
				}

				const pricing = tempDiv.querySelector( '.pricing-container' );
				if ( pricing ) {

					let isPricingUpdated = false;

					card.querySelectorAll( '.pricing-container' ).forEach( el => {
						let newPricing = pricing.cloneNode( true );
						el.replaceWith( newPricing );
						isPricingUpdated = true;
					} );

					if ( isPricingUpdated && typeof window.affirm !== 'undefined' ) {
						window.affirm?.ui?.ready?.(() => window.affirm.ui.refresh?.());
					}
				}

				const addToCart = tempDiv.querySelector( '.add-to-cart-container' );
				if ( addToCart ) {
					card.querySelectorAll( '.add-to-cart-container' ).forEach( el => {
						let newAddToCart = addToCart.cloneNode( true );
						el.replaceWith( newAddToCart );
						/**
						 * note if on the receiving end we use jQuery on() function,
						 * we will need to access the payload as event.originalEvent.detail
						 */
						window.dispatchEvent( new CustomEvent( 'ColibriEvent:INIT_ADD_TO_CART', { detail: newAddToCart } ) );
					} );
				}

			} )
			.catch( error => {
				card.classList.remove( 'loading' );
				console.error( error );
			} );
		}
	}

	/**
	 * we need this in case DOMContentLoaded has already occurred before this file got fully loaded
	 */
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initStateSelects );
	} else {
		initStateSelects();
	}

} )();
